import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../auth/actions';
import * as routes from '../../routes/const';

import { NitroLoading } from 'nitro-components';

class Logout extends Component {

  componentWillMount(){
    const { logout } = this.props.actions;
    const { router } = this.context;

    const redUrl = this.props.location.query.redirectUrl;

    // clear items in session storage
    sessionStorage.clear();
    logout();

    if(redUrl){
      window.location = redUrl;
    } else {
      router.push(routes.LOGIN);
    }
  }

  render() {
    return <NitroLoading screen />;
  }
}

Logout.propTypes = {
  actions: React.PropTypes.object.isRequired
};

Logout.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(authActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/features/logout/Logout.js